import { buildGlobalAction, buildInlineComputedView } from "./../../builder.js";
class RecoveryDataNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the contactDoubledWithOldPrefix global action. */
    this.contactDoubledWithOldPrefix = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactDoubledWithOldPrefix",
      operationName: "contactDoubledWithOldPrefix",
      operationReturnType: "RecoveryDataContactDoubledWithOldPrefix",
      namespace: ["recovery", "data"],
      variables: {}
    });
    /** Executes the contactIdsWithExpiredCustomCouponCode global action. */
    this.contactIdsWithExpiredCustomCouponCode = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "contactIdsWithExpiredCustomCouponCode",
      operationName: "contactIdsWithExpiredCustomCouponCode",
      operationReturnType: "RecoveryDataContactIdsWithExpiredCustomCouponCode",
      namespace: ["recovery", "data"],
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: ["recovery", "data"],
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  RecoveryDataNamespace
};
//# sourceMappingURL=data.js.map
